<template>
  <div class="homeBox">
    <div class="contentBox">
      <userDataBox :userData="userData" :platform="currentUserInfo.platform"></userDataBox>
      <newBox v-if="currentUserInfo.platform == 1"></newBox>
      <div class="dataBox">
        <p class="t">我的数据</p>
        <div class="dataList">
          <div v-for="(item, index) in dataList" :key="'data' + index" class="dataListItem">
            <p class="num">{{item.num}}</p>
            <p class="name">{{item.name}}</p>
          </div>
        </div>
      </div>
      <div class="function">
        <p class="t">常用功能</p>
        <ul class="functionListBox">
          <li class="functionItem" v-for="(item, index) in functionData" :key="index" @click="skip(item)">
            <img :src="item.icon" alt="">
            <span>{{item.title}}</span>
          </li>
        </ul>
      </div>
      <strategy v-if="currentUserInfo.platform == 1"></strategy>
    </div>
    <noticeBox v-if="currentUserInfo.platform == 1"></noticeBox>
    <bindWx v-if="currentUserInfo.platform == 1 && bindWxState" :id="currentUserInfo.sponsorId" @requestIsSubscribe="isSubscribe(true)" @handleClose="bindWxState = false"></bindWx>
  </div>
</template>

<script>
import home from '@/services/home'
import newBox from './components/new'
import { mapState } from 'vuex';
import noticeBox from './components/notice'
import bindWx from './components/bindWx'
import userDataBox from './components/userData'
import strategy from './components/strategy'
import { dataList, dataList2, functionData, functionData2 } from './config'
export default {
  data () {
    return {
      dataList: [],
      functionData: [],
      userData: {
        userName: null,
        sponsorName: null,
        sponsorAvatar: null,
      },
      bindWxState: false
    }
  },
  computed: {
    ...mapState({
      currentUserInfo: state => state.view.currentUserInfo,
      authMenuList: state => state.menus.authMenuList
    })
  },
  components: {
    noticeBox, userDataBox, newBox, strategy, bindWx
  },
  created () {
    if (this.currentUserInfo.platform == 1) {
      this.dataList = dataList2;
      this.functionData = functionData2;
      this.isSubscribe()
    } else {
      this.dataList = dataList;
      this.functionData = functionData;
    }
    this.isSkip()
    this.getData()
  },
  methods: {
    getData () {
      home.getHomeData().then(res => {
        if (res.code === 10024) {
          this.$message.error(res.message);
          return false;
        }
        if (this.currentUserInfo.platform == 1) {
          this.dataList[0].num = res.result.gamesCount
          this.dataList[1].num = res.result.leaderCount
          this.dataList[2].num = res.result.activityCount
          this.dataList[3].num = res.result.incomeFee.toFixed(2)
          this.dataList[4].num = res.result.waitSettleFee
          this.dataList[5].num = res.result.withdrawFee.toFixed(2)
          this.userData.userName = res.result.sponsorUserName;
          this.userData.sponsorName = res.result.sponsorName;
          this.userData.sponsorAvatar = res.result.sponsorAvatar;
        } else {
          this.dataList[1].num = res.result.sponsorTotal
          this.dataList[2].num = res.result.ticketIncome.toFixed(2)
          this.dataList[3].num = res.result.ticketServiceFee.toFixed(2)
          this.dataList[0].num = res.result.weiXinUserTotal;
          this.userData.userName = res.result.userName;
        }
      })
    },
    isSkip () {
      this.functionData.map(v => {
        this.authMenuList.some(s => {
          v.isAuthority = s.url === v.url;
          return s.url === v.url
        })
      })
    },
    isSubscribe(state = false) {
      home.isSubscribe().then(res => {
        this.bindWxState = !Object.is(res.code, 0)
        if (state && !Object.is(res.code, 0)) this.$message.error('当前登录账号未关注绑定微信公众号')
      })
    },
    skip (item) {
      if (item.isAuthority) {
        this.$router.push(item.path)
      } else {
        this.$message.error('您没有该功能的权限，请联系客服')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.homeBox {
  display: flex;
  .contentBox {
    flex: 1;
  }
  .t {
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 13px;
  }
  .functionListBox {
    overflow: hidden;
    .functionItem {
      width: 19%;
      // width: 242px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      background: linear-gradient(128deg, #5b9bfe 0%, #6b3ffc 100%);
      border-radius: 8px;
      margin-right: 8px;
      margin-bottom: 8px;
      color: #fff;
      font-size: 14px;
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
      img {
        width: 29px;
        height: 29px;
        vertical-align: middle;
      }
    }
  }
  .dataBox {
    margin-bottom: 24px;
  }
  .dataList {
    display: flex;
    background-color: #fff;
    color: #444;
    padding: 48px 0 46px;
    border-radius: 8px;
  }
  .dataListItem {
    text-align: center;
    flex: 1;
    line-height: 22px;
    .num {
      font-size: 28px;
      margin-bottom: 12px;
    }
    .name {
      font-size: 14px;
    }
  }
}
</style>